import styled from '@emotion/styled';

export const HeaderWrapper = styled.div`
  margin-bottom: 12px;
  border-bottom: 1px solid #ddd;
`;

export const HeaderTitle = styled.h1`
  margin: 0;
  margin-bottom: 8px;
  font-family: ${({ theme }) => theme.fonts.secondary};
  font-size: 24px;
  font-weight: normal;
  color: ${({ theme }) => theme.colors.danger};
`;

export const HeaderSubtitle = styled.p`
  margin: 0;
  margin-bottom: 18px;
  font-family: ${({ theme }) => theme.fonts.secondary};
`;

export const CardWrapper = styled.div`
  display: flex;
`;

export const Card = styled.div`
  margin-right: 30px;
  margin-bottom: 8px;
  padding: 6px 30px 6px 0;
  border-right: 1px solid #ddd;
  font-family: ${({ theme }) => theme.fonts.secondary};

  &:last-child {
    border: 0;
  }
`;

export const CardTitle = styled.label`
  display: block;
  margin: 0;
  margin-bottom: 6px;
  font-family: ${({ theme }) => theme.fonts.secondary};
  font-size: 14px;
  font-weight: 500;
`;

export const CardValue = styled.div`
  margin: 0;
  line-height: 20px;
  font-family: ${({ theme }) => theme.fonts.secondary};
`;

export const SelectionMessage = styled.p`
  margin: 0;
  margin-bottom: 30px;
  font-family: ${({ theme }) => theme.fonts.secondary};
  font-size: 14px;
  color: ${({ theme }) => theme.colors.danger};
`;
